<template>
  <div class="toggle">
    <el-button
      @click="toggle = !toggle"
      type="success"
      class="toggle__button button-success--blank">
      <span v-if="!toggle" class="toggle__text">{{moreText}}</span>
      <span v-else class="toggle__text --up">{{lessText}}</span>
      <font-awesome-icon :class="chevronClass" :icon="['fas', 'chevron-down']" />
    </el-button>
    <transition
      name="slide"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end">
      <div v-show="toggle">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  nameClassStyle: 'toggle',
  props: {
    initToggle: Boolean,
    moreText: {
      type: [Boolean, String],
      default: 'Voir plus',
    },
    lessText: String,
  },
  data() {
    return {
      toggle: null,
    };
  },
  computed: {
    chevronClass() {
      return {
        toggle__chevron__icon: true,
        'toggle__chevron__icon--rotate': this.toggle,
      };
    },
  },
  created() {
    this.toggle = this.initToggle;
  },
  methods: {
    start(el) {
      el.style.height = `${ el.scrollHeight }px`;
    },
    end(el) {
      el.style.height = '';
    },
  },
};
</script>

<style scoped lang="scss">
.toggle {
  margin: 10px auto;
  font-size: 15px;
  cursor: pointer;
  &__text {
    font-size: 14px;
    margin-top: 0;
    font-weight: 600;
    padding-right: 3px;
  }
  &__button {
    width: 100%;
  }
  &__chevron__icon {
    margin: auto 0 auto 8px;
    transition: transform 0.25s linear;
    &--rotate {
      transform: rotate(-180deg);
    }
  }
  .slide-enter-active, .slide-leave-active {
    transition: height 0.45s ease, opacity .45s ease;
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    height: 0 !important;
    opacity: 0;
  }
}
</style>
